export const lightBlue = '#5791E8';
export const transparentBlue = 'rgba(87, 145, 232, 0.64)';
export const text = 'rgba(0, 0, 0, 0.87)';
export const newFrameGrid = '#4B6172';
export const grey2 = '#1F2329';
export const grey3 = '#3D4149';
export const grey4 = '#262B33';
export const grey5 = '#474B54';
export const grey6 = '#464A52';
export const grey7 = '#2A2D34';
export const grey8 = '#757575';
export const purple = '#8678FF';
export const gradient = 'linear-gradient(75deg, #5791E8, #4E339B)';

export const white = '#fff';
export const darkBlack = '#000';
export const lightBlack = '#00000099';
export const lightGreen = '#9EB33F';
export const yellow = '#FFF600';
export const darkYellow = '#c0b707';
export const orange = '#FC8600';
export const green = '#008000';
export const darkGreen = '#005600';
export const lightGrey = '#BDBDBDB2';
export const grey = '#a0a0a0b2';
export const blackGrey = '#182628';
export const darkBlue = '#4285F4';
export const mediumAquamarine = '#46D8CF';
export const red = '#ff0000';
export const darkRed = '#a40000';

export const workedAreaColor = '#bdff00';
export const workedAreaColorHover = '#749b03';

export const NEON_GREEN = '#00FF00';
export const BRIGHT_BLUE = '#0000FF';
export const BRIGHT_ORANGE = '#FFA500';
const PURPLE = '#FF00FF';
const YELLOW = '#FFFF00';
const AQUAMARINE = '#00FFFF';
const PINK = '#FF1493';
const LIGHT_GREEN = '#7FFF00';
export const SKY_BLUE = '#1E90FF';
const LIME = '#32CD32';
const GOLD = '#FFD700';
const TURQUOISE = '#40E0D0';

const NEON_GREEN_SECOND = '#3aa23a';
const BRIGHT_BLUE_SECOND = '#6868b8';
const BRIGHT_ORANGE_SECOND = '#be9c60';
const PURPLE_SECOND = '#ad6aad';
const YELLOW_SECOND = '#aeae60';
const AQUAMARINE_SECOND = '#589f9f';
const PINK_SECOND = '#a75d83';
const LIGHT_GREEN_SECOND = '#7da456';
const SKY_BLUE_SECOND = '#587ca0';
const LIME_SECOND = '#579c57';
const GOLD_SECOND = '#968a4e';
const TURQUOISE_SECOND = '#578983';

export const trackColors = [
  { primary: NEON_GREEN, secondary: NEON_GREEN_SECOND },
  { primary: BRIGHT_BLUE, secondary: BRIGHT_BLUE_SECOND },
  { primary: BRIGHT_ORANGE, secondary: BRIGHT_ORANGE_SECOND },
  { primary: PURPLE, secondary: PURPLE_SECOND },
  { primary: YELLOW, secondary: YELLOW_SECOND },
  { primary: AQUAMARINE, secondary: AQUAMARINE_SECOND },
  { primary: PINK, secondary: PINK_SECOND },
  { primary: LIGHT_GREEN, secondary: LIGHT_GREEN_SECOND },
  { primary: SKY_BLUE, secondary: SKY_BLUE_SECOND },
  { primary: LIME, secondary: LIME_SECOND },
  { primary: GOLD, secondary: GOLD_SECOND },
  { primary: TURQUOISE, secondary: TURQUOISE_SECOND },
];
